import * as React from "react";
import { useRecordContext, RaRecord, useGetIdentity } from "react-admin";

type MyUrlFieldType = {
  recurso: string;
  source: string;
  alvo: string;
  sufixo?: string;
  numero?: boolean;
};

const MyUrlFieldErp = ({
  recurso,
  source,
  alvo,
  sufixo = "",
  numero = false,
}: MyUrlFieldType) => {
  const record = useRecordContext<RaRecord>();
  const { identity } = useGetIdentity();
  const baseUrl = identity?.homologacao
    ? "https://sandbox.rnge.com.br/app/index.html#/"
    : "https://app.rnge.com.br/#/";

  if (!record || record[alvo] == null) {
    return (
      <div
        style={{
          textAlign: numero ? "right" : "left",
          textDecoration: "line-through",
        }}
      >
        {record?.[source]}
      </div>
    );
  }

  return (
    <div style={{ textAlign: numero ? "right" : "left" }}>
      <a
        href={`${baseUrl}${recurso}/${record[alvo]}${sufixo}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {record[source]}
      </a>
    </div>
  );
};

export default MyUrlFieldErp;
